/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const wallet = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M14.067 7.533V5.355c0-.687-.558-1.244-1.245-1.244H12.2m1.867 3.422h-2.423a1 1 0 0 0-1 1v1.111a1 1 0 0 0 1 1h2.423m0-3.11c.515 0 .933.417.933.933V9.71a.933.933 0 0 1-.933.933m0 0v2.8c0 .688-.558 1.245-1.245 1.245H2.244A1.244 1.244 0 0 1 1 13.444V5.356c0-.688.557-1.245 1.244-1.245h1.867m0 0 5.907-3.063a1 1 0 0 1 1.416.592l.766 2.47m-8.089 0H12.2"
    />
  </svg>
)
export default wallet
